import { render, staticRenderFns } from "./FamousCreateTitleBar.vue?vue&type=template&id=776730a2&"
import script from "./FamousCreateTitleBar.vue?vue&type=script&lang=js&"
export * from "./FamousCreateTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports